'use client';
import Tags from "@/components/common/Tags";
import ImageGallery from "@/components/common/image-gallery";
import { PostContentFallback, useLoadPostBySlug } from "@/components/common/posts/posts.provider";
import { SimilarPosts } from "@/components/common/posts/similar-posts";
import SectionPage from "@/components/common/section-page";

export default function PostPage() {
    const {currentPost, postsBasePath} = useLoadPostBySlug("2026/08/reine-awoulaba-afrique-2026");

    return (
        <PostContentFallback>
            <article>
                <div style={{ backgroundImage: `url(${currentPost?.image})` }} className={"h-[400px] w-full bg-cover bg-center relative"}>
                    <div className={"bg-bleu-marine h-[100px] w-full flex items-center justify-start absolute bottom-0"}>
                        <SectionPage sectionType={"2xl"}>
                            <h1 className={"text-white text-4xl font-exo"}>{currentPost?.title}</h1>
                        </SectionPage>
                    </div>
                </div>

                <SectionPage sectionType={"xl"} className={"my-12"}>
                    <div className="markdown-content text-gray-800">
                        <p className="my-4 text-normal leading-relaxed">
                            Le samedi 1er août 2026, le Palais de la Culture d’Abidjan a accueilli la grande finale de la Reine Awoulaba d’Afrique – Côte d’Ivoire 2026, une soirée placée sous le signe de l’élégance et de la valorisation de la culture ivoirienne.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            Au terme de cette belle célébration, Mallan Sonia Nadège Rose N’Guessan, représentante de la région du Moronou, a été couronnée Reine Awoulaba 2026. 👑
                        </p>

                        <p className="my-4 text-normal leading-relaxed font-semibold">
                            Elle est accompagnée au palmarès par :
                        </p>

                        <ul className="list-disc list-inside my-4 pl-4 text-normal">
                            <li>🥈 1ère Saraman : Mlle Traoré Nakan – Commune de Port-Bouët</li>
                            <li>🥉 2ème Saraman : Mlle Sessegnon Ahihon Eudoxie – Commune du Plateau</li>
                        </ul>

                        <p className="my-4 text-normal leading-relaxed">
                            Cette édition aura une nouvelle fois mis en lumière la beauté, l’élégance, les traditions et la richesse culturelle des territoires ivoiriens.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            À travers ce rendez-vous, la Reine Awoulaba contribue également à promouvoir le tourisme culturel en Côte d’Ivoire, en mettant à l’honneur les femmes et les identités qui font la richesse du pays. 🇨🇮✨
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            Félicitations à la Reine et à ses Saraman ! 👑
                        </p>

                        <div className={'my-8'}>
                            <ImageGallery images={
                                Array.from({ length: 6 }).map((_, index) => ({
                                    src: `/images${postsBasePath}/${String(currentPost?.slug)}/${index + 1}.jpg`,
                                    alt: `image${index + 1}`,
                                    width: 700,
                                    height: 700,
                                }))
                            } aspectRatio={"video"} />
                        </div>

                        <Tags tags={['ReineAwoulaba', 'Awoulaba2026', 'Moronou', 'Abidjan', 'Culture', 'TourismeCulturel', 'CôtedIvoire', 'CôtedIvoireTourisme']} />
                    </div>

                    <SimilarPosts currentSlug={String(currentPost?.slug)} />
                </SectionPage>
            </article>
        </PostContentFallback>
    );
}
